import { render, staticRenderFns } from "./rateScore.vue?vue&type=template&id=61413942&scoped=true&"
import script from "./rateScore.vue?vue&type=script&lang=js&"
export * from "./rateScore.vue?vue&type=script&lang=js&"
import style0 from "./rateScore.vue?vue&type=style&index=0&id=61413942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61413942",
  null
  
)

export default component.exports